import Product from "../model/Product";
import SceneObjectData from "../model/sceneObjectData/SceneObjectData";

export enum VisualizerUserDataTypeEnum {
    productMesh,
    sceneObject
}
export interface VisualizerUserData {
    userDataType: VisualizerUserDataTypeEnum
}

export const isProductMeshUserData = (userData: any): userData is ProductMeshUserData => {
    return userData != null && 
            typeof userData === 'object' && 
            userData.userDataType === VisualizerUserDataTypeEnum.productMesh &&
            'product' in userData;
}

export interface ProductMeshUserData extends VisualizerUserData {
    product: Product
};

export interface SceneObjectUserData {
    sceneObjectData: SceneObjectData
}

